import classNames from 'clsx';
import React, { memo } from 'react';
import { formatAutoDeleteExpires, formatExpiresDropdown } from 'reactApp/utils/formatDate';

import styles from '../DataListItemRow.css';

export const Expires = memo(({ expires, isAutoDelete, isShared }: { expires?: number; isAutoDelete?: boolean; isShared?: boolean }) => {
    return (
        <div
            className={classNames({
                [styles.date_wide]: true,
                [styles.expires]: isShared,
                [styles.autodelete]: isAutoDelete,
            })}
        >
            {!!expires &&
                (isAutoDelete
                    ? `Удалится ${formatAutoDeleteExpires(expires, true)}`
                    : isShared && `Доступ открыт до ${formatExpiresDropdown(expires, true)}`)}
        </div>
    );
});

Expires.displayName = 'Expires';
